import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet'; 
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import HeroSection from './components/HeroSection';
import ApproachSection from './components/ApproachSection';
import JourneyTimeline from './components/JourneyTimeline';
import SkillsExpertise from './components/SkillsExpertise';
import PersonalTouchSection from './components/PersonalTouchSection';
import FunFacts from './components/FunFacts';
import CallToActionSection from './components/CallToActionSection';

const AboutPage = () => {
  useEffect(() => {
    // Set page title
    document.title = 'About - Professional Story & Expertise | Portfolio';
    
    // Scroll to top on page load
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        {/* Primary Meta Tags */}
        <title>About | Sudhan R – Space Tech Researcher & Computer Science Engineer</title>
        <meta name="description" content="Discover the professional journey of Sudhan R: from ISRO-NARL and NESAC internships to NASA STEM projects. Specializing in space research, geospatial analytics (GIS/UAV), full-stack development, and AI engineering." />
        <meta name="keywords" content="Sudhan R, ISRO intern, NASA STEM, space research, remote sensing, UAV, NDVI, NDRE, STEM education, atmospheric science, LiDAR, IAAC ambassador, India space internship, geospatial analysis, Pix4D, QGIS, Python, full-stack portfolio, Computer Science Engineer, Sri Eshwar College of Engineering, Data Scientist, Web Developer, Web3, React" />
        <meta name="author" content="Sudhan R" />
        <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />

        {/* Canonical */}
        <link rel="canonical" href="https://sudhan.live/about" />

        {/* Open Graph / Facebook */}
        <meta property="og:title" content="About | Sudhan R – Space-Tech Innovator, Developer & Researcher" />
        <meta property="og:description" content="From ISRO and NASA to national STEM outreach – discover how Sudhan bridges space science, remote sensing, and software engineering to build impact-driven innovations." />
        <meta property="og:type" content="profile" />
        <meta property="og:url" content="https://sudhan.live/about" />
        <meta property="og:image" content="https://sudhan.live/assets/images/Sudhan_2026_v3.png" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="About | Sudhan R – Space Researcher & STEM Mentor" />
        <meta name="twitter:description" content="Explore Sudhan R's professional journey spanning ISRO, NASA, Remote Sensing, STEM Outreach, and Full Stack Development." />
        <meta name="twitter:image" content="https://sudhan.live/assets/images/Sudhan_2026_v3.png" />

        {/* Structured Data (JSON-LD) */}
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@graph": [
              {
                "@type": "AboutPage",
                "@id": "https://sudhan.live/about#webpage",
                "url": "https://sudhan.live/about",
                "name": "About Me - Sudhan R",
                "description": "Detailed background, professional story, expertise, and scientific competencies of Sudhan R in software engineering and space technology.",
                "isPartOf": {
                  "@id": "https://sudhan.live/#website"
                },
                "mainEntity": {
                  "@id": "https://sudhan.live/#person"
                },
                "breadcrumb": {
                  "@id": "https://sudhan.live/about#breadcrumb"
                }
              },
              {
                "@type": "BreadcrumbList",
                "@id": "https://sudhan.live/about#breadcrumb",
                "itemListElement": [
                  {
                    "@type": "ListItem",
                    "position": 1,
                    "name": "Home",
                    "item": "https://sudhan.live/"
                  },
                  {
                    "@type": "ListItem",
                    "position": 2,
                    "name": "About",
                    "item": "https://sudhan.live/about"
                  }
                ]
              }
            ]
          }
          `}
        </script>
      </Helmet>
      <Header />
      
      <main className="pt-16 lg:pt-20">
        {/* Hero Section with Professional Photo and Introduction */}
        <HeroSection />
        
        {/* My Approach - Design Philosophy and Methodology */}
        <ApproachSection />
        {/* Skills & Expertise */}
        <SkillsExpertise />
        
        {/* Beyond Research & Core Values */}
        <PersonalTouchSection />

        {/* Fun Facts */}
        <FunFacts />
        
        {/* Call to Action - Resources and Contact */}
        <CallToActionSection />
      </main>
      
      <Footer />
    </div>
  );
};

export default AboutPage;